import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import * as React from 'react';
import { ESCAPE, Subscriber, getGlobalBehaviors } from '@cian/global-behaviors';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Компонента для добавления подписки на Escape через @cian/global-behaviors
 *
 * Добавление подписчика происходит после монтирования компоненты
 * Удаление подписчика происходит после размонтирования компоненты
 *
 * Рендерить компоненту нужно ТОЛЬКО в случаях если что-то реально отрендерится на экране
 *
 * @export
 * @param {IEscapeProps} props
 * @returns
 */
export var Escape = /*#__PURE__*/function (_React$Component) {
  _inherits(Escape, _React$Component);
  var _super = _createSuper(Escape);
  function Escape() {
    var _this;
    _classCallCheck(this, Escape);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    /**
     * По причине того, чтобы ссылка на эту функцию не менялась
     * Эту компоненту нельзя делать функциональной
     */
    _defineProperty(_assertThisInitialized(_this), "subscriber", new Subscriber(function () {
      if (_this.props.active) {
        _this.props.onEscape();
      }
    }));
    return _this;
  }
  _createClass(Escape, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      getGlobalBehaviors().subscribe(ESCAPE, this.subscriber);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      getGlobalBehaviors().unsubscribe(ESCAPE, this.subscriber);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$children;
      return /*#__PURE__*/_jsx(_Fragment, {
        children: (_this$props$children = this.props.children) !== null && _this$props$children !== void 0 ? _this$props$children : null
      });
    }
  }]);
  return Escape;
}(React.Component);
_defineProperty(Escape, "defaultProps", {
  active: true
});